import axios from "axios";

export const PostApiMethod = (
    routeName: string,
    body: object,
    headers: { [index: string]: { [index: string]: string } } = { headers: {} }
) => {
    return axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/${routeName}`,
        body,
        headers
    );
};

export const GetApiMethod = (routeName: string , headers: { [index: string]: { [index: string]: any } } = { headers: {} }) => {
    return axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/${routeName}`,headers
    );
};

export const PutApiMethod = (routeName: string, body: object) => {
    return axios.put(
        `${process.env.REACT_APP_API_ENDPOINT}/${routeName}`,
        JSON.stringify(body)
    );
};

export const DeleteApiMethod = (routeName: string) => {
    return axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/${routeName}`);
};

export const PostApiMethodForSSM = (
    routeName: string,
    body: object,
    headers: { [index: string]: { [index: string]: string } } = { headers: {} }
) => {
    return axios.post(
        `https://anytimestorage-wrapper.ssm-erp.com/${routeName}`,
        body,
        headers
    );
};